<template>
	<el-container class="friend-request-page" :class="{ embedded }">
		<el-header height="60px" class="header">
			<div class="header-content">
				<el-button v-if="!embedded" icon="el-icon-arrow-left" @click="$router.go(-1)">返回</el-button>
				<h2>好友申请</h2>
			</div>
		</el-header>
		<el-main class="main">
			<div v-if="requests.length === 0" class="empty-tip">
				<i class="el-icon-message"></i>
				<p>暂无好友申请</p>
			</div>
			<div v-else class="request-list">
				<div v-for="request in requests" :key="request.id" class="request-item">
					<div class="request-avatar">
						<head-image :name="request.fromUserNickName" :url="request.fromUserHeadImage"></head-image>
					</div>
					<div class="request-info">
						<div class="request-name">{{ request.fromUserNickName }}</div>
						<div class="request-message" v-if="request.message">{{ request.message }}</div>
						<div class="request-time">{{ formatTime(request.createdTime) }}</div>
					</div>
					<div class="request-actions" v-if="request.status === 0">
						<el-button type="primary" size="small" @click="acceptRequest(request)">同意</el-button>
						<el-button type="default" size="small" @click="rejectRequest(request)">拒绝</el-button>
					</div>
					<div class="request-status" v-else>
						<span v-if="request.status === 1" class="status-accepted">已同意</span>
						<span v-else-if="request.status === 2" class="status-rejected">已拒绝</span>
					</div>
				</div>
			</div>
		</el-main>
	</el-container>
</template>

<script>
import HeadImage from '../components/common/HeadImage.vue'
import { getPendingFriendRequestCount, mergeFriendRequestsBySender } from '../utils/friendRequest'

export default {
	name: "friendRequest",
	components: {
		HeadImage
	},
	props: {
		embedded: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			requests: []
		}
	},
	mounted() {
		this.loadRequests();
	},
	methods: {
		loadRequests() {
			return this.$http({
				url: "/friend-request/received",
				method: "GET"
			}).then((data) => {
				this.requests = mergeFriendRequestsBySender(data);
				this.$emit('requests-updated', this.requests || []);
				this.syncPendingRequestCount();
			}).catch((error) => {
				this.$message.error("加载申请列表失败");
			})
		},
		syncPendingRequestCount() {
			const count = getPendingFriendRequestCount(this.requests || []);
			sessionStorage.setItem('friendRequestCount', count);
			this.$eventBus.$emit('updateFriendRequestCount', count);
			return count;
		},
		markRequestHandled(request, status) {
			this.requests = (this.requests || []).map((item) => {
				if (item.id === request.id) {
					return { ...item, status };
				}
				return item;
			});
			this.$emit('requests-updated', this.requests || []);
			this.syncPendingRequestCount();
		},
		acceptRequest(request) {
			this.$confirm(`确认同意 ${request.fromUserNickName} 的好友申请吗？`, '确认同意', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'info'
			}).then(() => {
				this.$http({
					url: "/friend-request/accept/" + request.id,
					method: "POST"
				}).then(() => {
					this.$message.success("已同意好友申请");
					this.markRequestHandled(request, 1);
					this.loadRequests();
				}).catch((error) => {
					this.$message.error(error.message || "操作失败");
				})
			})
		},
		rejectRequest(request) {
			this.$confirm(`确认拒绝 ${request.fromUserNickName} 的好友申请吗？`, '确认拒绝', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: "/friend-request/reject/" + request.id,
					method: "POST"
				}).then(() => {
					this.$message.success("已拒绝好友申请");
					this.markRequestHandled(request, 2);
					this.loadRequests();
				}).catch((error) => {
					this.$message.error(error.message || "操作失败");
				})
			})
		},
		
		// 更新好友申请数量
		updateFriendRequestCount() {
			console.log('FriendRequest.vue 开始更新好友申请数量');
			// 重新检查好友申请数量
			this.$http({
				url: "/friend-request/received",
				method: "GET"
			}).then((data) => {
				// 过滤出待处理的好友请求
				const count = getPendingFriendRequestCount(data);
				
				console.log(`FriendRequest.vue 好友申请处理后，待处理数量: ${count}`);
				
				// 立即更新本地存储
				sessionStorage.setItem('friendRequestCount', count);
				console.log(`FriendRequest.vue 已更新本地存储: ${count}`);
				
				// 通过事件总线通知更新数量
				this.$eventBus.$emit('updateFriendRequestCount', count);
				console.log(`FriendRequest.vue 已发送事件: updateFriendRequestCount(${count})`);
				
			}).catch((error) => {
				console.error('FriendRequest.vue 更新好友申请数量失败:', error);
			});
		},
		
		formatTime(timeStr) {
			if (!timeStr) return '';
			const date = new Date(timeStr);
			const now = new Date();
			const diff = now - date;
			const minutes = Math.floor(diff / (1000 * 60));
			const hours = Math.floor(diff / (1000 * 60 * 60));
			const days = Math.floor(diff / (1000 * 60 * 60 * 24));
			
			if (minutes < 1) return '刚刚';
			if (minutes < 60) return `${minutes}分钟前`;
			if (hours < 24) return `${hours}小时前`;
			if (days < 7) return `${days}天前`;
			
			return date.toLocaleDateString();
		}
	}
}
</script>

<style lang="scss" scoped>
.friend-request-page {
	height: 100vh;

	&.embedded {
		height: 100%;

		.header {
			.header-content {
				justify-content: center;

				h2 {
					margin: 0;
				}
			}
		}
	}
	
	.header {
		background-color: #fff;
		border-bottom: 1px solid #e6e6e6;
		
		.header-content {
			display: flex;
			align-items: center;
			height: 100%;
			
			h2 {
				margin: 0 0 0 20px;
				font-size: 18px;
				color: #333;
			}
		}
	}
	
	.main {
		padding: 20px;
		
		.empty-tip {
			text-align: center;
			padding: 100px 0;
			color: #999;
			
			i {
				font-size: 48px;
				margin-bottom: 20px;
			}
			
			p {
				margin: 0;
				font-size: 14px;
			}
		}
		
		.request-list {
			.request-item {
				display: flex;
				align-items: center;
				padding: 20px;
				border-bottom: 1px solid #f0f0f0;
				background-color: #fff;
				border-radius: 8px;
				margin-bottom: 10px;
				
				.request-avatar {
					margin-right: 15px;
				}
				
				.request-info {
					flex: 1;
					
					.request-name {
						font-size: 16px;
						font-weight: bold;
						color: #333;
						margin-bottom: 5px;
					}
					
					.request-message {
						font-size: 14px;
						color: #666;
						margin-bottom: 5px;
					}
					
					.request-time {
						font-size: 12px;
						color: #999;
					}
				}
				
				.request-actions {
					display: flex;
					gap: 10px;
				}
				
				.request-status {
					.status-accepted {
						color: #1976d2;
						font-size: 14px;
					}
					
					.status-rejected {
						color: #f56c6c;
						font-size: 14px;
					}
				}
			}
		}
	}
}
</style> 
